module.exports = __webpack_public_path__ + "static/averta-regular-a4a94d228042e24a4409d452bc7bac64.woff2";